<template>
  <div class="main-box" v-if="info">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/order/index' }">订单</el-breadcrumb-item>
      <el-breadcrumb-item>订单详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="60" class="mg-tp-20">
      <el-col :span="12" style="border-right: 1px solid #f5f5f5">
        <el-divider content-position="left">订单详情</el-divider>
        <el-form size="small" label-position="left">
          <el-form-item label="订单号：" :label-width="formLabelWidth">
            {{ info.order_sn }}
          </el-form-item>
          <el-form-item label="下单时间：" :label-width="formLabelWidth">
            {{ info.create_time }}
          </el-form-item>
          <el-form-item label="状态：" :label-width="formLabelWidth">
            {{ info.status_str }}
          </el-form-item>
          <el-form-item label="支付状态：" :label-width="formLabelWidth" v-if="info.order_type!=3">
            {{ info.pay_status==1?'已支付':'未支付' }}
          </el-form-item>
          <el-form-item label="取消时间：" :label-width="formLabelWidth" v-if="info.cancel_time">
            {{ info.cancel_time }}
          </el-form-item>
          <el-form-item label="支付时间：" :label-width="formLabelWidth" v-if="info.pay_time && info.order_type!=3">
            {{ info.pay_time }}
          </el-form-item>
          <el-form-item label="确认时间：" :label-width="formLabelWidth" v-if="info.sure_time">
            {{ info.sure_time }}
          </el-form-item>
          <el-form-item label="交易单号：" :label-width="formLabelWidth" v-if="info.payment_sn">
            {{ info.payment_sn }}
          </el-form-item>
          <el-form-item label="支付方式：" :label-width="formLabelWidth" v-if="info.trade_sn">
            {{ info.pay_type==1?'微信支付':'支付宝' }}
          </el-form-item>
          <el-form-item label="支付单号：" :label-width="formLabelWidth" v-if="info.trade_sn">
            {{ info.trade_sn }}
          </el-form-item>
          <el-form-item :label="info.pay_type==1?'微信单号':'支付宝单号'" :label-width="formLabelWidth" v-if="info.three_sn">
            {{ info.three_sn }}
          </el-form-item>
          <el-form-item label="发货时间：" :label-width="formLabelWidth" v-if="info.shipments_time">
            {{ info.shipments_time }}
          </el-form-item>
          <el-form-item label="收货时间：" :label-width="formLabelWidth" v-if="info.delivery_time">
            {{ info.delivery_time }}
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-divider content-position="left">买家信息</el-divider>
        <el-form size="small" label-position="left">
          <el-form-item label="买家：" :label-width="formLabelWidth" v-if="info.member">
            {{ info.member.name }}（{{ info.member.user_id }}） - {{ info.member.mobile }}
          </el-form-item>
          <el-form-item label="配送方式：" :label-width="formLabelWidth">
            物流配送
          </el-form-item>
          <el-form-item label="收货人：" :label-width="formLabelWidth" v-if="info.address">
            {{ info.address.name }} - {{ info.address.mobile }}
          </el-form-item>
          <el-form-item label="收货地址：" :label-width="formLabelWidth" v-if="info.address">
            {{ info.address.province_name }} {{ info.address.city_name }} {{ info.address.district_name }} {{ info.address.address }}
          </el-form-item>
          <div v-if="info.package">
            <el-form-item label="发货信息：" :label-width="formLabelWidth">
              <div v-if="info.package.logis_type==1">
                {{ info.package.logis_name }} - {{ info.package.logis_no }} <span class="mg-lf-20">备注：{{info.package.remark}}</span>
              </div>
              <div v-else>
                无需物流 <span class="mg-lf-20">备注：{{info.package.remark}}</span>
              </div>
              <ul class="picList" v-if="info.package.pics && info.package.pics.length>0">
                <li v-for="(item,index) in info.package.pics" :key="index">
                  <img class="image-img" :src="item" />
                </li>
              </ul>
              <el-button type="primary" @click="showDeliverGoods()">发货商品</el-button>
            </el-form-item>
          </div>
          <el-form-item label="用户备注：" :label-width="formLabelWidth">
            {{ info.remark }}
          </el-form-item>

          <el-form-item label="">
            <el-popconfirm v-if="info.status==0" class="mg-rt-10"
                title="确认取消当前订单吗？"
                @confirm="orderCancel"
            >
              <el-button type="primary" size="mini" slot="reference">取消</el-button>
            </el-popconfirm>
            <el-button type="warning" size="mini" @click="dialogVisible=true" v-if="info.status==1">发货</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-divider content-position="left">商品信息</el-divider>
    <el-table
        :data="info.goods"
        ref="rfTable"
        border
        style="width: 100%"
        :span-method="objectSpanMethod"
        size="mini">
      <el-table-column
          prop="goods"
          label="商品">
        <template slot-scope="scope">
          <div class="goods-box line">
            <div class="item">
              <img :src="scope.row.goods_img" class="img" />
              <div>
                <div class="name1">{{scope.row.goods_name}}</div>
                <div class="spec">{{scope.row.specs_name}}</div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          prop="quantity"
          label="数量"
          align="center"
          width="120">
      </el-table-column>
      <el-table-column
          prop="price"
          label="单价(元)"
          align="center"
          width="120">
      </el-table-column>
      <el-table-column v-if="info.order_type==2"
          prop="price"
          label="天数"
          align="center"
          width="120">
        <template>
          {{ info.days }}
        </template>
      </el-table-column>
      <el-table-column
          prop="pay_price"
          label="商品总价(元)"
          align="center"
          width="120">
        <template slot-scope="scope">
          {{ info.goods_amount }} <span style="display: none">{{scope.row.id}}</span>
        </template>
      </el-table-column>
<!--      <el-table-column v-if="info.refund_status>0"-->
<!--          prop="refund_status"-->
<!--          label="售后"-->
<!--          align="center"-->
<!--          width="120">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.id}}-->
<!--          <el-button type="text" v-if="info.refund_status==1" size="small" @click="orderRefundDetail()">退款申请中</el-button>-->
<!--          <el-button type="text" v-if="info.refund_status==2" size="small" @click="orderRefundDetail()">退款完成</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <el-row :gutter="60" class="mg-tp-20 mg-bt-20 pd-bt-20" v-if="info.order_type!=3">
      <el-col :span="24" style="border-right: 1px solid #f5f5f5">
        <el-divider content-position="left">汇总</el-divider>
        <el-form size="small" label-position="left">
          <el-form-item label="商品总价：" :label-width="formLabelWidth">
            ￥{{ info.goods_amount }}
          </el-form-item>
        </el-form>
        <el-form size="small" label-position="left" v-for="(item,index) in info.ump" :key="index">
          <el-form-item :label="item.ump_type" :label-width="formLabelWidth">
            -￥{{ item.amount }}
          </el-form-item>
        </el-form>
<!--        <el-form size="small" label-position="left">-->
<!--          <el-form-item label="运费：" :label-width="formLabelWidth">-->
<!--            ￥{{ info.shipment_fee }}-->
<!--          </el-form-item>-->
<!--        </el-form>-->
<!--        <el-form size="small" label-position="left">-->
<!--          <el-form-item label="实付金额：" :label-width="formLabelWidth">-->
<!--            ￥{{ info.amount }}-->
<!--          </el-form-item>-->
<!--        </el-form>-->
      </el-col>
    </el-row>
    <el-dialog
        title="订单发货"
        :visible.sync="dialogVisible"
        :destroy-on-close="true"
        width="800px">
      <order-delivery :orderId="id" :callback="res => { dialogVisible=false; getOrderInfo() }"></order-delivery>
    </el-dialog>
    <el-dialog
        title="发货商品"
        :visible.sync="dialogDeliverVisible"
        :destroy-on-close="true"
        width="800px">
      <el-table
          :data="info.package_goods"
          ref="rfTable"
          style="width: 100%"
          size="mini">
        <el-table-column
            prop="goods_name"
            label="商品">
        </el-table-column>
        <el-table-column
            prop="specs_name"
            label="规格"
            align="center">
          <template slot-scope="scope">
            {{scope.row.specs_name || '-'}}
          </template>
        </el-table-column>
        <el-table-column
            prop="quantity"
            label="发货数量"
            align="center"
            width="100">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>

import ClipboardJS from "clipboard";
import OrderDelivery from "@/components/OrderDelivery";
export default {
  components: {
    OrderDelivery
  },
  data() {
    return {
      id: 0,
      info: false,
      formLabelWidth: '90px',
      dialogVisible: false,
      dialogDeliverVisible: false,
      step: false,
      stepIdx: -1
    };
  },
  created() {
    if (this.$route.params.id) {
      this.id = parseInt(this.$route.params.id)
      this.getOrderInfo()
    }
  },
  mounted() {
  },
  computed: {},
  methods: {
    showDeliverGoods() {
      this.dialogDeliverVisible = true
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex >= this.info.goods.length+2) {
        return {
          rowspan: 3,
          colspan: 1
        };
      }
    },
    getOrderInfo() {
      this.$api.order.orderDetail({id:this.id}, res => {
        if(res.errcode==0) {
          this.info = res.data
          var step = [];
          if(this.info.delivery_type==1) {
            step.push('买家下单')
            step.push('买家支付')
            step.push('卖家发货')
            step.push('订单完成')
            if(this.info.status==0) {
              this.stepIdx = 1
            } else if(this.info.status==1) {
              this.stepIdx = 2
            } else if(this.info.status==2) {
              this.stepIdx = 3
            } else if(this.info.status==3) {
              this.stepIdx = 4
            } else {
              step = false
            }
          } else if(this.info.delivery_type==2) {
            step.push('买家下单')
            step.push('买家支付')
            step.push('上门提货')
            step.push('订单完成')
            if(this.info.status==0) {
              this.stepIdx = 1
            } else if(this.info.status==1) {
              this.stepIdx = 2
            } else if(this.info.status==4) {
              this.stepIdx = 3
            } else if(this.info.status==3) {
              this.stepIdx = 4
            } else {
              step = false
            }
          }
          this.step = step
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    copyTxt(txt) {
      var _this = this
      var clipboard = new ClipboardJS('#copyId', {
        text: function () {
          return txt;
        },
      });
      clipboard.on('success', function (e) {
        _this.success('复制成功')
      });
      clipboard.on('error', function (e) {
        _this.fail('复制失败')
      });
    },
    orderCancel() {
      var _this = this
      this.$api.order.orderCancel({id: this.id}, res => {
        if (res.errcode == 0) {
          _this.success('取消成功')
          _this.getOrderInfo()
        } else {
          _this.fail(res.errmsg)
        }
      })
    },
    orderRefundDetail() {
      this.$router.push({name: 'order_refund_detail', params: {id: this.info.id}})
    }
  }
};
</script>
<style scoped>
.gdtable tr {
  background-color: unset;
  border-bottom: 1px solid #f5f5f5
}
.gdtable tr:last-child {
  border-bottom: none !important;
}
.gdtable td {
  padding: 5px 0;
}
.el-form-item {
  margin-bottom: 5px;
}
/* 移除table组件hover背景色 */
.el-table__row:hover> td{
  background: #fff !important;
}
</style>
